import React from 'react'

const Blogs = () => {
    return (
        <div className="wrapper">
            <div className='arrow-1'></div>
            <div className="blog-boxer A">
                <img className='blog-img' alt='blog image' src='https://images.squarespace-cdn.com/content/v1/60818be3726c6c6c3f24a841/1622140128102-KWTH9R30PZ4DOZ9UN9KB/Mental+Health.png' />
                <div className='blog-buttons'>
                    <div className='blog-text'>Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                    </div>
                    <div className='blog-set'>
                        <a href='https://www.nami.org/Blogs/NAMI-Blog'>Read More</a>
                    </div>
                </div>
            </div>
            <div className="blog-boxer B">
                <img className='blog-img' alt='blog image' src='https://vidhilegalpolicy.in/wp-content/uploads/2021/10/mental-health-wellness-during-covid-19.jpg' />
                <div className='blog-buttons'>
                    <div className='blog-text'>Sed euismod tellus id urna ultricies, in ultricies justo efficitur.</div>
                    <div className='blog-set'>
                        <a href='https://blurtitout.org/'>Read More</a></div>
                </div>
            </div>
            <div className='arrow-2'></div>
            <div className="blog-boxer C"><img className='blog-img' alt='blog image' src='https://fhsphoenix.org/wp-content/uploads/2021/12/istockphoto-1153386698-612x612-1.jpg' />
                <div className='blog-buttons'>
                    <div className='blog-text'>Proin sagittis tellus id nisi scelerisque, vitae vestibulum metus scelerisque.</div>
                    <div className='blog-set'>
                        <a href='https://www.mind.org.uk/'>Read More</a>
                    </div>
                </div></div>
            <div className="blog-boxer D">
                <img className='blog-img' alt='blog image' src='https://img.freepik.com/free-vector/mental-health-awareness-concept_52683-37916.jpg' />
                <div className='blog-buttons'>
                    <div className='blog-text'>Nulla facilisi. Suspendisse potenti.</div>
                    <div className='blog-set'>
                        <a href='https://themighty.com/'>Read More</a>
                    </div>
                </div>
            </div>
            <div className="blog-boxer E">
                <img className='blog-img' alt='blog image' src='https://cdn.pixabay.com/photo/2022/08/19/17/51/brain-7397412_640.png' />
                <div className='blog-buttons'>
                    <div className='blog-text'>Vestibulum ultricies leo eu neque malesuada, in sodales nisi pretium.</div>
                    <div className='blog-set'>
                        <a href='https://bevoya.com/'>Read More</a>
                    </div>
                </div>
            </div>
            <div className="blog-boxer F"><img className='blog-img' alt='blog image' src='https://akm-img-a-in.tosshub.com/indiatoday/images/story/media_bank/202310/the-major-mental-health-disorders-currently-faced-by-the-youth-in-the-indian-subcontinent-are-depres-101509553-1x1.jpg?VersionId=2UXaT8vUcvYejHFMADkxmxdWlFdKZz.L' />
                <div className='blog-buttons'>
                    <div className='blog-text'>Vestibulum ultricies leo eu neque malesuada, in sodales nisi pretium.</div>
                    <div className='blog-set'>
                        <a href='https://bevoya.com/'>Read More</a>
                    </div>
                </div></div>
            <div className='blog-boxer G'><img className='blog-img' alt='blog image' src='https://foodandmoodcentre.com.au/wp-content/uploads/sites/129/2018/05/healthy-body-healthy-mind-800x600.png' />
                <div className='blog-buttons'>
                    <div className='blog-text'>Duis condimentum dolor vel justo condimentum accumsan.</div>
                    <div className='blog-set'>
                        <a href='https://blurtitout.org/'>Read More</a>
                    </div>
                </div></div>
        </div>
    )
}

export default Blogs
